// extracted by mini-css-extract-plugin
export default {"cls1":"KUB6x9DQst4mjd6MpfD3","cls2":"mWn_Z5q_wC7wEJ1c2Bm2 KUB6x9DQst4mjd6MpfD3","profileBack":"BpIUGkB9wWTURRaMSYrB"};